import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Lang } from '@/lib/index';

interface LangContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (ro: string, en: string) => string;
}

const LangContext = createContext<LangContextType>({
  lang: 'ro',
  setLang: () => undefined,
  t: (ro) => ro,
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>('ro');
  const t = (ro: string, en: string) => (lang === 'ro' ? ro : en);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
